module.exports = __webpack_public_path__ + "static/media/covi_wel_was_col.14b3209f.png";